import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private router = inject(Router);
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  constructor() {
    this.currentUrl = this.router.url;
    
    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.urlAfterRedirects;
    });
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  getCurrentUrl(): string | null {
    return this.currentUrl;
  }

  /**
   * Comprueba si venimos de una sub-ruta de la URL padre
   * Útil para saber si estamos volviendo de un detalle
   */
  isComingFromChildOf(parentUrl: string): boolean {
    if (!this.previousUrl) return false;
    // Si la anterior empieza por la del padre y son distintas, es un detalle/hija
    return this.previousUrl.startsWith(parentUrl) && this.previousUrl !== parentUrl;
  }
}
